import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonComponentsModule } from '@app/modules/common/common.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LegalNoticeComponent } from './legal-notice.component';
export const routes: Routes = [
    {
        path: '',
        component: LegalNoticeComponent,
    }
];
@NgModule({
    imports: [
        RouterModule.forChild(routes),
        CommonComponentsModule,
        FormsModule,
        CommonModule
    ],
    declarations: [
        LegalNoticeComponent
    ],
    exports: [
    ]
})

export class LegalNoticeModule {

}
